import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { selectAllArticles, selectAudioState, selectCurrentlyPlayingArticle } from '../../article/data/articleSlice'
import { IArticleTransformed } from '../../article/types/IArticleTransformed'
import {
    popQueuedArticleById,
    popSuggestedArticleById,
    selectQueuedArticles,
    selectSuggestedArticles,
    setArticleToPlayAfterQueue,
    setSuggestedArticles,
} from '../queueSlice'

export function useQueue() {
    const dispatch = useAppDispatch()
    const articles = useAppSelector(selectAllArticles)

    const updateArticleToPlayAfterQueue = (article: IArticleTransformed) => {
        const indexOfCurrentArticle = articles.findIndex(a => a.id === article.id)
        let indexOfNextArticle = (indexOfCurrentArticle + 1) % articles.length
        dispatch(setArticleToPlayAfterQueue(articles[indexOfNextArticle]))
    }

    return { updateArticleToPlayAfterQueue }
}

export default function useQueueMain() {
    const dispatch = useAppDispatch()
    const queuedArticles = useAppSelector(selectQueuedArticles)
    const articles = useAppSelector(selectAllArticles)

    const audioState = useAppSelector(selectAudioState)
    const currentlyPlayingArticle = useAppSelector(selectCurrentlyPlayingArticle)
    const suggestedArticles = useAppSelector(selectSuggestedArticles)

    useEffect(() => {
        // whenever the currentPlayingArticle gets updated then check if the article is in queue
        // and if yes then remove it from the queue
        const queuedArticle = queuedArticles.find(article => article.queueId === currentlyPlayingArticle?.queueId)
        if (audioState === 'playing' && queuedArticle) {
            dispatch(popQueuedArticleById(queuedArticle.queueId))
            return
        }

        // read above comment first then + if article is not present then check in the suggestedArticles
        // and if yes then remove it from the queue

        const suggestedArticle = suggestedArticles.find(article => article.queueId === currentlyPlayingArticle?.queueId)
        if (audioState === 'playing' && suggestedArticle) {
            dispatch(popSuggestedArticleById(suggestedArticle.queueId))
            return
        }

        // remove from suggested if non-queued gets played
        const isNonQueuedPlayingArticleInSuggested = suggestedArticles.find(
            article => article.id === currentlyPlayingArticle?.id
        )
        if (audioState === 'playing' && isNonQueuedPlayingArticleInSuggested) {
            dispatch(popSuggestedArticleById(isNonQueuedPlayingArticleInSuggested.queueId))
            return
        }
    }, [audioState, currentlyPlayingArticle])

    useEffect(() => {
        if (articles.length) {
            dispatch(
                // making this filter checking because there could be existing queued articles from localStorage
                setSuggestedArticles([
                    ...articles.filter(article => !queuedArticles.some(qArticle => qArticle.id === article.id)),
                ])
            )
        }
    }, [articles])
}
